import {ReactNode} from 'react';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';

import './OptionBlock.sass';

type OptionBlockProps = {
  title: string;
  isActive: boolean;
  onToggleClickHandler: (value: boolean) => void;
  dataQaId: string;
  children: ReactNode;
};

export const OptionBlock = ({
  title,
  onToggleClickHandler,
  dataQaId,
  isActive,
  children,
}: OptionBlockProps) => {
  const onChangeHandler = ({target: {checked}}: React.ChangeEvent<HTMLInputElement>) =>
    onToggleClickHandler(checked);

  return (
    <div className="option-block">
      <div className="option-block__content">
        <Typography variant="paragraph2" semibold>
          {title}
        </Typography>
        <div>{children}</div>
      </div>
      <Input
        type="toggle"
        checked={isActive}
        onChange={onChangeHandler}
        data-qa-id={dataQaId}
        value={isActive}
      />
    </div>
  );
};
